import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { QuickAdd } from '@ui/general';
import { InitiativeStatus, InitiativeType } from '@sonar-software/sonar-core';
import React, { useEffect, useRef } from 'react';
import { useCreateInitiative, useCurrentUser } from '@hooks';
export const CreateInitiative = ({ noPadding, onFinish, source }) => {
    const { id: userId } = useCurrentUser();
    const { isProcessing, isSuccessful, result, request } = useCreateInitiative();
    const isCreatingRef = useRef(false);
    const onFinishRef = useRef(onFinish);
    onFinishRef.current = onFinish;
    useEffect(() => {
        if (isSuccessful && result && isCreatingRef.current) {
            isCreatingRef.current = false;
            if (onFinishRef.current) {
                onFinishRef.current(result);
            }
        }
    }, [isProcessing, onFinish, isSuccessful, result]);
    return (React.createElement(QuickAdd, { className: 'create-initiative', noPadding: noPadding, onSubmit: (value) => {
            isCreatingRef.current = true;
            request({
                assignedTo: userId,
                description: '',
                initiativeStatusId: InitiativeStatus.New,
                initiativeTypeId: InitiativeType.Improvement,
                source,
                title: value
            });
        }, processing: isProcessing, toggleProps: {
            className: 'create-initiative-button',
            id: 'initiatives-create-open-form-button'
        }, typeLabel: COPY_SPECIFIC.INITIATIVE }));
};
